import React from 'react';
import isInRange from '../platformui/Base/Sensors/isInRange';
import ChapterContainer from '../platformui/ChapterContainer';
import withAnchorNavTrigger from '../platformui/Containers/withAnchorNavTrigger';

const ChapterContainerBlock = (props) => {
  let showBlocksInMobileAlways = true;
  const containerProps = { ...props, showBlocksInMobileAlways };
  return <ChapterContainer {...containerProps} />;
};
export default isInRange(withAnchorNavTrigger(ChapterContainerBlock), 65);
